import apolloClient from "app/graphql/apolloClient";
import customerActions from "../actions";
import queryLoader from "app/graphql/queryLoader";
import messagesActions from "core/state/redux/data/messages/actions";
import commonActions from "../../common/actions";

const EDIT_CUSTOMER_ADDRESS = "editCustomerAddress";

export default async (store, action) => {
  try {
    const { data } = await apolloClient.mutate({
      mutation: queryLoader(EDIT_CUSTOMER_ADDRESS),
      variables: action.request,
    });

    if (data && data.updateCustomerAddress) {
      // let token = store.getState().state.customer.token;
      await store
        .dispatch(
          customerActions._reduceCustomerAddress(data.updateCustomerAddress)
        )
        .then(
          store.dispatch(
            messagesActions.addMessage(
              "Successfully updated address information.",
              "success"
            )
          )
        )
        .then(store.dispatch(commonActions.unlock("success")));
    }
  } catch (error) {
    store.dispatch(messagesActions.addMessage(error.toString(), "danger"));
    store.dispatch(commonActions.unlock());
    return;
  }
};
